import React, { PureComponent } from 'react';
import PropTypes from "prop-types";
import styles from "./style.css";
import { createClassNames } from "../../../../infrastructure/helpers";

export default class HorizontalSwitch extends PureComponent {
  static defaultProps = {
    keyExtractor: (item, index) => index,
    labelExtractor: (item, index) => item.title,
    onPress: (item, index) => {},
    items: []
  };

  static propTypes = {
    keyExtractor: PropTypes.func,
    labelExtractor: PropTypes.func,
    onPress: PropTypes.func,
    selectedItem: PropTypes.any,
    items: PropTypes.array,
    containerStyles: PropTypes.object,
    contentContainerStyle: PropTypes.object
  };

  isItemSelected = (item, index) => {
    return this.props.selectedItem &&
      this.props.keyExtractor(this.props.selectedItem, index) === this.props.keyExtractor(item, index);
  };

  onButtonPressed = (item, index) => {
    this.props.onPress(item, index);
  };

  renderButton(item, index) {
    const key = this.props.keyExtractor(item, index);

    const isSelected = this.isItemSelected(item, index);
    const lineStyle = [styles.line];
    if (isSelected) {
      lineStyle.push(styles.lineSelected);
    }

    const lineClass = createClassNames(lineStyle);

    return (
      <button type="button"
              key={key}
              onClick={() => this.onButtonPressed(item, index)}
              className={styles.btn}>
        <span className={styles.btnLabel}>{ this.props.labelExtractor(item) }</span>
        <div className={lineClass}/>
      </button>
    )
  }

  render() {
    const scrollClass = createClassNames([styles.scroll, this.props.containerClass]);
    return (
      <div className={styles.scrollWrap} style={this.props.containerStyles}>
        <div className={scrollClass}
             style={this.props.contentContainerStyle}>
          { this.props.items.map((item, index) => this.renderButton(item, index)) }
          <div className={styles.scrollSpacer} />
        </div>
      </div>
    );
  }
}